var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorWarningCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 2C6.47976 2 1.99976 6.48 1.99976 12C1.99976 17.52 6.47976 22 11.9998 22C17.5198 22 21.9998 17.52 21.9998 12C21.9998 6.48 17.5198 2 11.9998 2ZM11.9998 13C11.4498 13 10.9998 12.55 10.9998 12V8C10.9998 7.45 11.4498 7 11.9998 7C12.5498 7 12.9998 7.45 12.9998 8V12C12.9998 12.55 12.5498 13 11.9998 13ZM12.9998 17H10.9998V15H12.9998V17Z",
    fill: "#E53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarningCircle);
export default __webpack_public_path__ + "static/media/ErrorWarningCircle.997aed5dd1bcbb9c1ede7a380c3b2cd7.svg";
export { ForwardRef as ReactComponent };